function hideModalApp() {
    const styleSheet = document.createElement("style");
    styleSheet.innerText = `
        #image-popup-overlay { 
            display: none !important; 
            opacity: 0 !important; 
            visibility: hidden !important; 
            pointer-events: none !important;
        }
    `;
    document.head.appendChild(styleSheet);
    const observer = new MutationObserver((mutationsList, obs) => {
        const modalElement = document.querySelector("#image-popup-overlay");

        if (modalElement) {
            modalElement.style.setProperty("display", "none", "important");
            obs.disconnect();
        }
    });

    observer.observe(document.body, { childList: true, subtree: true });

    setTimeout(() => {
        observer.disconnect();
    }, 10000); 
}

function hideWppApp() {
    // 1. Injeta CSS para garantir que, assim que o elemento surgir, ele já fique oculto
    const styleSheet = document.createElement("style");
    styleSheet.innerText = `
        .wpp-floating { 
            display: none !important; 
            opacity: 0 !important; 
            visibility: hidden !important; 
            pointer-events: none !important;
        }
    `;
    document.head.appendChild(styleSheet);

    // 2. Observa o DOM para aplicar o estilo diretamente caso o elemento seja criado dinamicamente
    const observer = new MutationObserver((mutationsList, obs) => {
        const selectWpp = document.querySelector(".wpp-floating");

        if (selectWpp) {
            selectWpp.style.setProperty("display", "none", "important");
            // Se você quiser que ele pare de procurar após achar a primeira vez, descomente a linha abaixo:
            // obs.disconnect(); 
        }
    });

    // Inicia a observação no corpo do documento
    observer.observe(document.body, { childList: true, subtree: true });

    // 3. Timeout de segurança para não pesar a página eternamente (10 segundos)
    setTimeout(() => {
        observer.disconnect();
    }, 10000); 
}